import React from 'react'
import { Route } from 'react-router'
import RedirectToPlural from '@/modules/layout/util/redirectToPlural'

const ManualCreditNoteDetails = React.lazy(() => import('@/modules/invoice/components/detail/invoice-detail-view'))
const ManualCreditNoteEditView = React.lazy(() => import('@/modules/manualCreditNote/manual-credit-note-edit-view'))
const TransactionSendEmail = React.lazy(() => import('@/modules/transaction/components/email/transaction-send-email'))

const manualCreditNoteRoutes = (
  <>
    <Route path='manualcreditnote/*' element={<RedirectToPlural />} />
    <Route path='manualcreditnotes/:id' Component={ManualCreditNoteDetails} />
    <Route path='manualcreditnotes/:id/:action' Component={ManualCreditNoteDetails} />

    <Route path='manualcreditnotes/edit/:id' Component={ManualCreditNoteEditView} />
    <Route path='manualcreditnotes/new' Component={ManualCreditNoteEditView} />
    <Route path='manualcreditnotes/new/customer/:customerId' Component={ManualCreditNoteEditView} />
    <Route path='manualcreditnotes/send/:id' Component={TransactionSendEmail} handle={{ options: { noBackgroundColor: true } }} />
  </>
)

export default manualCreditNoteRoutes
